export const PENDING_INVITE_TOKEN_KEY = "pendingInviteToken";
export const RECENTLY_ACCEPTED_INVITE_TOKEN_KEY = "recentlyAcceptedInviteToken";

const INVITE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{20,128}$/;
const INVITE_RETURN_TO_ORIGIN = "https://app.wavegen.ai";

export function returnToWithPendingInviteToken(
  returnTo: string,
  pendingInviteToken: string | null | undefined,
): string {
  const token = pendingInviteToken?.trim();
  if (!token || !INVITE_TOKEN_PATTERN.test(token)) return returnTo;
  try {
    const url = new URL(returnTo, INVITE_RETURN_TO_ORIGIN);
    if (
      url.origin !== INVITE_RETURN_TO_ORIGIN ||
      url.pathname !== "/invite"
    ) {
      return returnTo;
    }
    const fragment = new URLSearchParams(url.hash.slice(1));
    fragment.set("token", token);
    return `${url.pathname}${url.search}#${fragment.toString()}`;
  } catch {
    return returnTo;
  }
}

export function inviteTokenFromReturnTo(
  returnTo: string | null | undefined,
): string | null {
  if (!returnTo) return null;
  try {
    const url = new URL(returnTo, INVITE_RETURN_TO_ORIGIN);
    if (url.pathname !== "/invite") return null;
    const token = new URLSearchParams(url.hash.slice(1)).get("token")?.trim();
    return token && INVITE_TOKEN_PATTERN.test(token) ? token : null;
  } catch {
    return null;
  }
}

export function inviteTokenFromSignInLocation(location: {
  pathname: string;
  search: string;
}): string | null {
  if (location.pathname !== "/finish-signin") return null;
  const returnTo = new URLSearchParams(location.search).get("returnTo");
  return inviteTokenFromReturnTo(returnTo);
}
